import { RadioGroup } from "@headlessui/react";
import {
  BriefcaseIcon,
  CheckCircleIcon,
  KeyIcon,
  UserCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";
import BikesForm from "../../forms/BikesForm";
import PartsForm from "../../forms/PartsForm";
import GesucheForm from "../../forms/GesucheForm";

const navigationList = [
  {
    name: "OEM & Aftermarket Parts",
    href: "#",
    icon: BriefcaseIcon,
    current: true,
  },
  {
    name: "Bikes & Rolling Chassis",
    href: "#",
    icon: UserCircleIcon,
    current: false,
  },
  { name: "Gesuche", href: "#", icon: KeyIcon, current: false },
];
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const FormSwitcher = (props) => {
  switch (props.form) {
    case "OEM & Aftermarket Parts":
      return <PartsForm />;
      break;
    case "Bikes & Rolling Chassis":
      return <BikesForm />;
      break;
    case "Gesuche":
      return <GesucheForm />;
      break;
    default:
      return <PartsForm />;
      break;
  }
};

function NewProduct() {
  const [navigation, setNavigation] = useState(navigationList);
  const [form, setCurrentForm] = useState("OEM & Aftermarket Parts");

  const switchMenu = (key) => {
    setCurrentForm(key);
    setNavigation(
      navigation.map((item) => {
        if (item.name === key) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      })
    );
  };

  // useEffect(() => {
  //     document.body.classList.add('bg-gray-100');

  //     return () => {
  //       document.body.classList.remove('bg-gray-100');
  //     }
  //   }, [])
  const getHeading = (category) => {
    switch (category) {
      case "OEM & Aftermarket Parts":
        return "PARTS";
      case "Bikes & Rolling Chassis":
        return "MOTORRAD";
      case "Gesuche":
        return "GESUCHE";
      default:
        return "";
    }
  };
  return (
    <>
      <HeaderBar title={getHeading(form)} back={1} />
      <div className="mt-10 sm:mt-0">
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Parts Informationen
              </h3>
              <p className="mt-1 text-sm text-gray-600">
                Je mehr Felder ausführlich ausgefüllt werden, desto besser lässt
                sich der Artikel finden.
              </p>
            </div>
            <aside className="mt-4 py-6 px-2 sm:px-6 lg:col-span-3 lg:py-0 lg:px-0">
              <nav className="space-y-1">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => switchMenu(item.name)}
                    className={classNames(
                      item.current
                        ? "bg-gray-50 text-indigo-700 hover:text-indigo-700 hover:bg-white"
                        : "text-gray-900 hover:text-gray-900 hover:bg-gray-50",
                      "group rounded-md px-3 py-2 flex items-center text-sm font-medium w-full"
                    )}
                    aria-current={item.current ? "page" : undefined}
                  >
                    <item.icon
                      className={classNames(
                        item.current
                          ? "text-indigo-500 group-hover:text-indigo-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    <span className="truncate">{item.name}</span>
                  </button>
                ))}
              </nav>
            </aside>
          </div>
          <div className="mt-5 md:col-span-2 md:mt-0">
            <FormSwitcher form={form} />
          </div>
        </div>
      </div>
    </>
  );
}

export default NewProduct;
